<template>
  <img src="@/assets/images/logos/company-logo-tjm.webp"/>
</template>
<script setup>
</script>